module.exports = __webpack_public_path__ + "static/img/landing-page-top.60ba4f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/sachassou/landing-page-top.jpg
// module id = Yf9e
// module chunks = 1